import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getAccountScopeUserSettings } from "owa-session-store";

export const WIN32_STYLE_ENABLED_SETTING_NAME = "win32style_enabled";

// Reads the primed style setting without initializing the live Win32 style store.
export function getWin32StyleEnabledFromPrimeSettings(): boolean {
    const primeSettings = getAccountScopeUserSettings(getGlobalSettingsAccountMailboxInfo())?.PrimeSettings;
    const item = primeSettings?.Items?.find(setting => typeof setting.Id === "string" &&
        setting.Id.toLowerCase() === WIN32_STYLE_ENABLED_SETTING_NAME);
    return item?.Value?.[0]?.value === "true";
}
